import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authClient } from './authClient';

const LoginCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    authClient.userManager
      .signinRedirectCallback()
      .then(() => {
        navigate('/');
      })
      .catch((err: Error) => {
        console.error('Login callback error:', err);
        // You could add UI feedback or redirect here if desired
      });
  }, [navigate]);

  return <div>Processing login...</div>;
};

export default LoginCallback;
